<!-- EXECUTIVE DASHBOARD -->
<nz-tabset>
  <ng-container class="nzTabNames" *ngFor="let clientDO of clientDoList">
    <nz-tab nzTitle="{{clientDO | MMSClientData: 'fullName'}}">
      
      <!-- <div *ngIf="appMetadataHandler.featureFlags.showDynamicLabReportsData; else showLocalDataForLabReports">
        <app-bill-details-advanced [requirements]="labReportRequirements" [IO]="IO" [transactionState]="transactionState"
        [RequirementEntityGuid]="RequirementEntityGuid"></app-bill-details-advanced>
      </div> -->

      <div *ngIf="appMetadataHandler.featureFlags.showDynamicLabReportsData; else showLocalDataForLabReports">
        <app-ocr-details [labReportRequirements]="labReportRequirements" [IO]="IO" [showLabReportSummary]="showLabReportSummary" 
        [transactionState]="transactionState" [clientDO]="clientDO" (updateValidatedData)="updateValidatedData($event)"
        [RequirementEntityGuid]="RequirementEntityGuid" (updateSelectedReportData)="updateSelectedReportData($event)"
        (emitMedicalReportSummary) = "fetchedMedicalReportSummary($event)"></app-ocr-details>
      </div>

      <!-- AGENTS SEARCH TABLE -->
      <ng-template #showLocalDataForLabReports>
      <div class="m-t-20" >
        <div class="w-100-pc">
          <div class="widget widget-shadow">
            <div class="flexie-auto-grid">
              <h5 class="d-b p-t-b-10">
                <span *ngIf="!searchTerm">All Health Parameters extracted from uploaded lab reports</span>
                <span *ngIf="searchTerm">Search Results</span>
              </h5>
              <div class="text-a-right">
                <nz-input-group [nzSuffix]="suffixIconSearch" style="max-width: 260px">
                  <input type="text" nz-input placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="agentSearch()"/>
                </nz-input-group>
                <ng-template #suffixIconSearch>
                  <i *ngIf="!searchTerm" class="anticon anticon-search"></i>
                  <i *ngIf="searchTerm" (click)="searchTerm=null" nzTheme="fill" class="ant-input-clear-icon anticon anticon-close-circle"></i>
                </ng-template>
              </div>
            </div>
            <nz-table #basicTable [nzData]="dataSetMedical" nzSize="small" [nzShowPagination]="false" class="d-b" [nzScroll]="{x: '480px'}"
                      [nzLoading]="isSearching || !widgetReady">
              <thead>
              <tr>
                <th style="width:40px"></th>
                <th>Test</th>
                <th>Result</th>
                <th>Unit</th>
                <th>Normal Range</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let u of basicTable.data">
                <td><nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="default" nzIcon="user" ></nz-avatar></td>
                <td>
                  <!-- <a [routerLink]="['/app/agent-analytics']">{{u.name}}</a> -->
                  <a>{{u.test}}</a>
                </td>
                <td>{{u.result}}</td>
                <td>{{u.unit}}</td>
                <td>{{u.range}}</td>
                <td>
                  <!-- <a [routerLink]="['/app/agent-analytics']">View Details</a> -->
                  <a>Rectify Value</a>
                  <nz-divider nzType="vertical"></nz-divider>
                  <!-- <a [routerLink]="['/app/agent-analytics']">Analyzeg</a> -->
                  <a>Ignore</a>
                </td>
              </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
      </ng-template>
      
      <ng-container *ngIf="(selectedReportDataAvailable || !appMetadataHandler.featureFlags.showDynamicLabReportsData)">

      <div class="ui-dashboard"> <!--*ngIf="clientDO['clientSpecificRequirement'].length > 0"-->
        <div class="dashboard-wrapper p-10">

          <div class="heading-tab" style="border-bottom: 0px;">
            <h3 class="heading"><em nz-icon nzType="file-done" nzTheme="outline"></em> Insights
            </h3>
          </div>
          <!-- <div class="p-b-10">
          <div class="grid grid-gap-20 grid-2x grid-2x-responsive p-b-20">
            <div>
              <h2 class="dashboard-head">Executive Dashboard</h2>
              <p class="dashboard-head-sub">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf; line-height: 0.5"
                          [nzSrc]="'https://randomuser.me/api/portraits/women/26.jpg'" nzSize="small" nzIcon="user">
                </nz-avatar>
                <strong class="p-l-10 p-r-5 d-i-b">Welcome back, Reshmi!</strong> Here's a quick summary of key data points
              </p>
            </div>
            <div class="text-a-right">
              <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDashDataChange(1200)" class="dash-date-range">

              </nz-range-picker>
              <nz-select style="display: inline-block; text-align: left; width: 166px;" nzPlaceHolder="Select Color Scheme"
                        [(ngModel)]="colorSchemeTempModel" (ngModelChange)="colorSchemeModelChange()">
                <nz-option *ngFor="let cs of colorSchemesNames; let i=index;" [nzValue]="i" [nzLabel]="cs"></nz-option>
              </nz-select>
            </div>

          </div>
        </div> -->

        <!-- Corporate content Slideshow -->
        <!-- <div class="m-b-10 d-b w-100-pc-force">
          <nz-carousel *ngIf="widgetReady" [nzEffect]="effect" [nzAutoPlay]="true" [nzAutoPlaySpeed]="5000" [nzEnableSwipe]="true"  style="width:100%">
            <div nz-carousel-content *ngFor="let c of carouselContent" style="height: auto">
              <div class="carousel-content" style="height: auto">
                <nz-tag [nzColor]="colorScheme.domain[0]">Corporate Updates</nz-tag>
                <h3 class="d-i-b p-r-10">{{c.title}}:</h3>
                <p class="d-i-b">{{c.content}}</p>
              </div>
            </div>
          </nz-carousel>
        </div> -->

        <!-- TOP WIDGETS -->
        <nz-tabset class="test" [nzTabPosition]="'top'">
          <nz-tab nzTitle="Primary Analysis">
            <div class="w-100-pc-force dash-grid-2x">
        
              <div class="w-100-pc">
                <div class="widget widget-height-fix__exec-top" style="border-radius:0px; border-right: 1px solid #dddddd;">
        
                  <div *ngIf="!widgetReady">
                    <nz-skeleton [nzActive]="true"></nz-skeleton>
                    <nz-skeleton [nzActive]="true"></nz-skeleton>
                  </div>
        
                  <div *ngIf="widgetReady">
        
                    <!-- Top two widgets -->
                    <div *ngIf="showRiskSection" class="grid grid-2x grid-gap-0 grid-2x-responsive">
                      <div>
                        <div class="widget-small-analytics">
                          <div class="content">
                            <div class="widget-small-grid">
                              <div>
                                <div class="numbers">
                                  <p>Framingham Risk <span></span></p>
                                  <strong class="col-green">{{framingham_risk}} %</strong>
                                </div>
                              </div>
                              <div>
                              </div>
                            </div>
                            <div class="widget-small-footer">
                              <div class="stats">
                                Assessment: Higher the average Framingham Risk score
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="widget-small-analytics">
                          <div class="content">
                            <div class="widget-small-grid">
                              <div>
                                <div class="numbers">
                                  <p>Risk Score<span></span></p>
                                  <strong class="color-">{{risk_score}}/10</strong>
                                </div>
                              </div>
                              <div class="p-0">
                                <nz-progress [nzPercent]="risk_score_graph" nzType="dashboard" [nzWidth]="65"></nz-progress>
                              </div>
                            </div>
                            <div class="widget-small-footer">
                              <div class="stats">
                                Overall Risk is higher to 40% of the customer
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
        
                    <!-- TIMELINE -->
                    <h5 >
                      Abnormal Findings   
                    </h5>
        
                    <!-- <nz-timeline>
                      <ng-container *ngFor="let riskPointer of labTestResults; let i = index;">
                      <nz-timeline-item  *ngIf="i < 5 && riskPointer.recommendation" nzColor="blue">
                          <p>
                            {{userDetails.recommendation}}
                            <nz-tag [nzColor]="'blue'">Score: {{riskPointer.riskScore}}</nz-tag>
                          </p>
                      </nz-timeline-item>
                    </ng-container> -->
                    <!-- <p> 
                      {{userDetails.recommendation}}  -->
                      <!-- <nz-tag [nzColor]="'blue'">Score: {{riskPointer.riskScore}}</nz-tag> -->
                    <!-- </p> -->
                    <div *ngIf="userDetails && userDetails.recommendation && userDetails.recommendation === 'message'">
                      <div *ngIf="userDetails.recommendation === 'message'">
                          High Sugar Levels - Fasting 125 mg/dl, Postprandial 150 mg/dl <br> Tobacco Consumption since 6 years
                      </div>
                  </div>
                  <div *ngIf="userDetails && userDetails.recommendation && userDetails.recommendation !== 'message'">
                      {{ userDetails.recommendation }}
                  </div>
                  

                      <!-- <nz-timeline-item nzColor="blue">
                        <p>
                          LDL Cholesterol is higher than normal range
                          <nz-tag [nzColor]="'blue'">Physiological Risk</nz-tag>
                        </p>
                      </nz-timeline-item>
                      <nz-timeline-item>
                        <p>
                          HbA1C is higher than non-diabetic range
                          <nz-tag [nzColor]="'blue'">Physiological Risk</nz-tag>
                        </p>
                      </nz-timeline-item>
                      <nz-timeline-item>
                        <p>C-Reactive protien (CRP) levels in high risk zone at 3.4 mg/L
                          <nz-tag [nzColor]="'blue'">Physiological Risk</nz-tag>
                        </p>
                      </nz-timeline-item> -->
                    <!-- </nz-timeline> -->

                    <div *ngIf="medicalSummary">
                      <h5 class="d-b p-t-10 p-b-20">
                        Medical Report Summary
                      </h5>
                      {{medicalSummary}}
                    </div>
        
                  </div>
        
                </div>
              </div>
        
              <div class="w-100-pc">
        
                <div class="widget" style="padding:20px 30px">
                  <div class="m-b-20">
                    <nz-row [nzGutter]="[0,16]">
                      <nz-col [nzSpan]="7">
                        <nz-card>
                          <nz-statistic [nzValue]="healthParams.HEIGHT" [nzTitle]="'Height'" ></nz-statistic>
                        </nz-card>
                      </nz-col>
                      <nz-col [nzSpan]="7">
                        <nz-card>
                          <nz-statistic [nzValue]="healthParams.WEIGHT" [nzTitle]="'Weight'" ></nz-statistic>
                        </nz-card>
                      </nz-col>
                      <nz-col [nzSpan]="10">
                        <nz-card>
                          <nz-statistic [nzValue]="healthParams.BMI" [nzTitle]="'BMI'" [nzSuffix]="suffixTpl"></nz-statistic>
                        </nz-card>
                        <ng-template #suffixTpl><span  nz-typography [nzType]="clientDO['BMIColor']" style="font-size: 18px;font-weight: 600;" >({{clientDO['BMIcategory']}})</span></ng-template>
                      </nz-col>
                    </nz-row>
                  </div>

                  <div class="text-a-right">
                    <nz-radio-group [(ngModel)]="medicalRiskView" [nzButtonStyle]="'solid'">
                      <label nz-radio-button nzValue="tileView">Tile View</label>
                      <label nz-radio-button nzValue="graphicalView">Graphical View</label>
                    </nz-radio-group>
                  </div>
                  <!-- <h5 class="d-b p-t-10 p-b-10">
                        Medical Parameters at risk for insured: <span class="col-green" style="font-size: 0.9rem;">{{clientDO | MMSClientData: 'fullName'}} </span>
                      </h5> -->
        
                  <!-- Empty states -->
                  <ng-container *ngIf="!widgetReady">
                    <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
                      <p><i nz-icon nzType="loading" nzTheme="outline"></i>&nbsp; Loading ...</p>
                    </div>
                  </ng-container>
                  <div *ngIf="medicalRiskView == 'tileView'">
                    <!-- <div style="width: 100%;display: grid; grid-template-columns: repeat(1,1fr)">
                      <ngx-charts-number-card [hidden]="!widgetReady" [results]="dataCARDS" [scheme]="colorScheme">
                      </ngx-charts-number-card>
                    </div> -->
                    <div class="grid grid-3x grid-3x-responsive grid-gap-20 m-t-b-20">
                      <div class="tileCards" *ngFor="let data of dataCARDS;let i = index;" [style.background]="colorScheme.domain[i]">
                        <div style="font-size:24px;">{{data.value}}</div>
                        <div>{{data.name}}</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="medicalRiskView == 'graphicalView'">
                    <div [hidden]="!widgetReady"class="healthCareNrewardSec">
                      <div class="healthCareSec">
                        <!-- <div class="healthCareTitle">Health Care</div> -->
                        <div class="healthCareBody">
        
                          <div class="healthCareContent healthCareSleep">
                            <!-- <div class="healthCareArrow"></div> -->
                            <div class="healthCareIcon">
                              <i nz-icon nzType="message" nzTheme="outline"></i>
                            </div>
                            <div *ngIf="userDetails && userDetails.pulseRate" class="healthCareData">
                              <span>{{userDetails.pulseRate}}bpm</span>
                              <!-- <span>hours</span> -->
                            </div>
                            <div class="healthCareDetail">Pulse Rate</div>
                          </div>
        
                          <div class="healthCareContent healthCareHeart">
                            <!-- <div class="healthCareArrow"></div> -->
                            <div class="healthCareIcon">
                              <i nz-icon nzType="heart" nzTheme="outline"></i>
                            </div>
                            <div *ngIf="userDetails && userDetails.cholesterol" class="healthCareData">
                              <span>{{userDetails.cholesterol}}mg/dl</span>
                            </div>
                            <div class="healthCareDetail">CHOLESTEROL</div>
                          </div>
        
                          <div class="healthCareContent healthCareTemp">
                            <!-- <div class="healthCareArrow"></div>  -->
                            <div class="healthCareIcon">
                              <!-- <i class="fa fa-medkit"></i> -->
                              <span nz-icon nzType="environment" nzTheme="outline" [nzRotate]="180"></span>
                            </div>
                            <div *ngIf="userDetails && userDetails.hba" class="healthCareData">
                              <span>{{userDetails.hba}}</span>
                            </div>
                            <div class="healthCareDetail">HbA1C</div>
                          </div>
        
                          <div class="healthCareContent healthCareBp">
                            <!-- <div class="healthCareArrow"></div> -->
                            <div class="healthCareIcon">
                              <i class="fa fa-stethoscope"></i>
                              <i nz-icon nzType="medicine-box" nzTheme="outline"></i>
                            </div>
                            <div *ngIf="userDetails && userDetails.bp" class="healthCareData">
                              <span>{{userDetails.bp}}</span>
                            </div>
                            <div class="healthCareDetail">BLOOD PRESSURE</div>
                          </div>
        
                        </div>
                        <!-- <div class="healthCareFooter">
                                  <div class="healthCareBtmImg1"><i class="fa fa-check-circle"></i></div>
                                  <div class="healthCareBtmImg2"><i class="fa fa-plus-circle"></i></div>
                                  <div class="healthCareBtmImg3"><i class="fa fa-plus-circle"></i></div>
                              </div> -->
                      </div>
                      <!-- <div class="hCrewardSec">
                              <div class="hcRewardBox">
                                  <div class="hcRewardBoxContent">
                                      <div>
                                          <div class="hcRewardRank">
                                              <span>3</span>
                                          </div>
                                          <div class="hcRewardStatus">Congratulations</div>
                                          <div class="hcRewardDetail">You rank 3rd for fitness in the organisation</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="hcCaloriesDetails">
                                  <div class="hcCaloriesImg">
                                      <img src="img/calories.png" class="img-responsive" />
                                  </div>
                                  <div class="hcCaloriesData">1600 Net Daily</div>
                              </div>
                              <div class="hcCaloriesBtnSec">
                                  <a target="_blank" href="https://sovereign.lifestaging.site/"><button class="btn btnGrey">Know more</button></a>
                              </div>
                          </div> -->
                    </div>
        
                  </div>
        
                  <h5 class="d-b p-t-10 p-b-10">
                    Cardiovascular Risk
                  </h5>
                  <div nz-row>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                      <div class="widget-small-analytics">
                        <div class="content">
                          <div nz-row>
                            <div nz-col nzMd="16">
                              <div class="numbers">
                                <p>Risk For Next 10 Years</p>
                                <div *ngIf="userDetails && userDetails.riskstatus">
                                  <strong *ngIf="userDetails.riskstatus === 'LOW'" class="col-green">Low</strong>
                                  <strong *ngIf="userDetails.riskstatus === 'MEDIUM'" class="col-orange">MEDIUM</strong>
                                  <strong *ngIf="userDetails.riskstatus === 'VERY_HIGH'" class="col-red">Very High</strong>
                                </div>
                                 
                              </div>
                            </div>
                            <div col nzMd="8">
                              <div class="icon-big icon-warning text-center">
                                <i nz-icon nzType="profile" nzTheme="outline"></i>
                              </div>
                            </div>
                          </div>
                          <div class="widget-small-footer">
                            <!-- <div class="stats">
                              Higher LDR and CRP are <b>strong</b> indicators of Cardiovascular Risk
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                      <div class="widget-small-analytics">
                        <div class="content">
                          <div nz-row>
                            <div nz-col nzMd="16">
                              <div class="numbers">
                                <p>Age</p>
                                <strong class="color-">{{clientDO.age}} Years</strong>
                              </div>
                            </div>
                            <div col nzMd="8">
                            </div>
                          </div>
                          <div class="widget-small-footer">
                            <!-- <div class="stats">
                              <b>Age</b> suspectable to Cardiovascular high risk zone
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
        
        
                </div>
              </div>
        
            </div>
          </nz-tab>

          <nz-tab nzTitle="Medical Rules" *ngIf="false">

            <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Showing rules
              ({{TEST_RULES_DATA.length}})</h3>

            <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false">
              <thead class="table-header">
                <tr>
                  <th>Rule Name </th>
                  <!-- <th>Rule Category</th> -->
                  <th>Decision</th>
                  <th>Recommendation</th>
                </tr>
              </thead>
              <tbody class="">
                <tr class="table-row" *ngFor="let rule of TEST_RULES_DATA">
                  <td class="">{{((rule.name || rule.ruleName) | technicalTranslate) || "-"}}</td>
                  <!-- <td class="">{{(rule.category | technicalTranslate) || "-"}}</td> -->
                  <td>{{(rule.decision | technicalTranslate) || "-"}}</td>
                  <!-- <td
                    [class.col-green]="rule.decision=='Accepted' || rule.decision=='ACCEPTED' || rule.decision=='STANDARD'"
                    [class.col-red]="rule.decision=='Refer' || rule.decision=='REFER'" class="">
                    {{(rule.decision | technicalTranslate) || "-"}}</td> -->
                  <!-- <td class="">{{rule.decisionValue || "-"}}</td> -->
                  <td class="">{{(rule.recco || rule.recommendation) || "-"}}</td>
                </tr>
                <!-- </ng-container> -->
              </tbody>
            </nz-table>
          </nz-tab>

          <nz-tab nzTitle="Medical Rules">

            <!-- <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Showing rules </h3> -->

            <!-- <nz-table *ngIf="labTestResults && labTestResults.length > 0" [nzData]="[1,2,3]" [nzShowPagination]="false">
              <thead class="table-header">
                <tr>
                  <th>Test Name </th>
                  <th>Reason</th>
                  <th>Result</th>
                  <th>Risk Rating</th>
                  <th>Risk Score</th>
                  <th>Recommendation</th>
                </tr>
              </thead>
              <tbody class="">
                <tr class="table-row" *ngFor="let rule of labTestResults">
                  <td class="">{{((rule.testCd) | technicalTranslate) || "-"}}</td>
                  <td class="">{{rule.reason || "-"}}</td>
                  <td>{{(rule.result | technicalTranslate) || "-"}}</td>
                  <td>{{(rule.riskRating | technicalTranslate) || "-"}}</td>
                  <td class="">{{rule.riskScore || "-"}}</td>
                  
                  <td class="">{{rule.recommendation || "-"}}</td>
                </tr>
              </tbody>
            </nz-table> -->

            <app-data-list *ngIf="refreshMedicalRulesFlag" [listOfData]="labTestResults" filterBasedOn="result" [title]="'Rules'" [listFor]="'MEDICAL_RULES'"></app-data-list>
             
          </nz-tab>
        </nz-tabset>

        <!--<nz-progress [nzPercent]="100" nzStatus="active" [nzShowInfo]="false"></nz-progress>-->


        <!-- -- >
        <div class="d-b">
          <div class="widget-wrapper" *ngIf="widgetReady" style="height: 140px">
            <div class="widget-responsive">
              <ngx-charts-number-card
                class="chart-container"
                [view]="view"
                (legendLabelClick)="onSelect($event)"
                [scheme]="colorSchemeForest"
                cardColor="#f9f9f9"
                emptyColor="#1e222e"
                [results]="card"
              >
              </ngx-charts-number-card>
            </div>
          </div>
        </div>
        -->

        </div><!-- /wrapper -->

      </div>
    </ng-container>
    </nz-tab>
  </ng-container>
</nz-tabset>
